const constant = {
    REQ_BANNER_LIST: "ad.list",
    REQ_MOVIE_LIST_HOT: "movie.hot.list",
    REQ_MOVIE_DETAIL: "movie.detail",
    REQ_MOVIE_LIST_FUTURE: "movie.future.list",
    REQ_MOVIE_CINEMA_LIST: "movie.cinema.list",
    REQ_MOVIE_CINEMA_DETAIL: "movie.cinema.detail",
    REQ_MOVIE_ACTOR_IMAGE_GET: 'movie.movieActor.getActorPicture',
    REQ_MOVIE_CINEMA_DATE_LIST: "movie.opi.date.list",
    REQ_MOVIE_SESSION_LIST: "movie.opi.list",
    REQ_MOVIE_CINEMA_SEAT: "movie.opi.seat",
    REQ_MOVIE_CINEMA_SEAT_VALIDATE: 'movie.seat.validposition',
    REQ_MEMBER_ORDER_CREATE: 'member.order.create',
    REQ_MEMBER_ORDER_GET: 'member.order.get',
    REQ_MEMBER_ORDER_UNPAID_GET: 'member.h5.movieOrder.getUnpaidOrder',
    REQ_MEMBER_ORDER_REMAINING: 'member.order.remaining',
    REQ_MEMBER_ORDER_COUPON_LIST: 'member.coupon.available.list',
    REQ_MEMBER_COUPON_ORDER_MODIFY: 'member.order.coupon.modify',
    REQ_MEMBER_VIP_ORDER_MODIFY: 'member.order.coupon.vipcard.modify',
    REQ_MEMBER_VIP_ADD: 'member.coupon.vipcard.bind',
    REQ_MEMBER_COUPON_GET: 'member.coupon.get',
    REQ_MEMBER_COUPON_ADD: 'member.coupon.bind',
    REQ_MEMBER_COUPON_LIST: 'member.coupon.list',
    REQ_MEMBER_COUPON_VIP_LIST: 'member.coupon.vipcard.list',
    REQ_MEMBER_ORDER_LIST: 'member.h5.movieOrder.list',
    REQ_MEMBER_ORDER_CANCEL: 'member.order.cancel',
    REQ_MEMBER_ORDER_DELETE: 'member.order.del',
    REQ_MEMBER_ORDER_DETAIL_GET: 'member.h5.movieOrder.getByTradeNo',
    REQ_MOVIE_CITY_LIST: "movie.city.list",
    REQ_MOVIE_COUNTY_LIST: 'movie.county.list'
};

export default constant;
